<div class="wrap">
  <button class="close-button" (click)="closeModal()"><span class="icon-close"></span></button>
  <ng-container>
    <header>
      <h2 class="heading">{{ 'common.userRole.userRoleHeading' | translate }} <span class="headerName">{{ user.name }}</span></h2>
    </header>
    <div class="content">
      <div class="card">    
        <div class="col-wrap">
          <div class="col">
            <img class="user-avatar" *ngIf="user.picture" [src]="user.picture" alt="demo-avatar">
            <img class="user-avatar" *ngIf="!user.picture" src="https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png" alt="demo-avatar">
          </div>
          <div class="col">
            <h4><span class="userName">{{ user.name }}</span></h4>
            <h4><span class="userEmail">{{ user.email ? user.email : 'common.nonavailable' | translate }}</span></h4>
            <h4><span class="userRole">{{ user.access }}</span></h4>
          </div>
        </div>  
        <form [formGroup]="userRoleForm">
          <span class="select_role">{{ 'access_control.dialog.search_role' | translate }}</span>
          <div class="col-wrap">
            <div class="col">
              <app-role-selector
                [role]="roleOptions"
                (selected)="onRoleSelectionChanged($event)"
              >
              </app-role-selector>
            </div>
          </div>
        </form>
      </div>
    </div>
    <footer>
      <button
        class="bciti-button bciti-button--black-inversed" 
        data-cy="cancel-button" 
        (click)="cancel()">{{'common.userRole.cancel' | translate}}</button>
      <button 
        class="bciti-button bciti-button--black"
        *ngIf="roleOptions.length > 0" 
        (click)="save()">{{ 'common.userRole.save' | translate }}</button>
    </footer>
  </ng-container>
</div>
